import {useTranslation} from "react-i18next";

import {useSelectByCurrentLanguage} from "../../hooks/languageHooks";
import ParameterInputSelectButtons from "./ParameterInputSelectButtons";
import {useInputParameterDef} from "./paramHooks";

export default function ParameterInputCategoryButtons({
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    maxCategories,
    associatedOutputParam,
}) {
    const {t} = useTranslation();
    const selectByCurrentLanguage = useSelectByCurrentLanguage();
    const parameterData = useInputParameterDef(parameter, parameter_details_def);

    if (!parameterData || !Array.isArray(parameterData.categories) || !parameterData.categories.length) return null;

    const categories =
        maxCategories != null ? parameterData.categories.slice(0, maxCategories) : parameterData.categories;
    const options = categories.map((category) => {
        const shortName = selectByCurrentLanguage(category.shortNameDe, category.shortNameEn);
        const group = category.groupDe ? selectByCurrentLanguage(category.groupDe, category.groupEn) : undefined;
        // Grobkategorie der Gruppe (#19431)
        const isGroupCategory = group != null && category.shortNameDe === category.groupDe;
        return {
            value: category.categoryNumber,
            label: isGroupCategory ? t("object.categoryGroupUnspecified") : shortName,
            valueLabel: shortName,
            title: selectByCurrentLanguage(category.titleDe, category.titleEn),
            group,
        };
    });

    return (
        <ParameterInputSelectButtons
            parameter={parameter}
            parameterType={parameterType}
            label={label}
            id={id}
            parameter_details_def={parameter_details_def}
            options={options}
            multiple={parameterData.type === "category[]"}
            associatedOutputParam={associatedOutputParam}
            resolveOptionValue={(value) => value}
        />
    );
}
